export default __webpack_public_path__ + "static/media/kitchen5-afterA-1024w.9ab7ea1c.avif";